// TODO: rework Input component with new TS component from /atoms/Input
import React from 'react';

import subYears from 'date-fns/sub_years';

import { Formik } from 'formik';
import * as Yup from 'yup';

import Form from '@zego/forms/Form';
import FormActions from '@zego/forms/FormActions';
import FormField from '@zego/forms/FormField';
import FormFieldGroup from '@zego/forms/FormFieldGroup';
import Input from '@zego/forms/Input';
import SplitDateInput from '@zego/forms/SplitDateInput';
import { BREAKPOINTS, errorColor, unit } from '@zego/theme';

import H4 from '@zego/components/atoms/H4';
import RegularText from '@zego/components/atoms/RegularText';
import View from '@zego/components/atoms/View';
import Button from '@zego/components/button';
import Link from '@zego/components/Link';

const LeadDetailsForm = ({
  className,
  onSubmit,
  buttonLabel,
  errorMessage,
}) => {
  const validationSchema = Yup.object().shape({
    'given-name': Yup.string().required('Required'),
    'family-name': Yup.string().required('Required'),
    email: Yup.string().required('Required'),
    tel: Yup.string()
      .required('Required')
      .min(10, 'Your phone number must be at least 10 digits'),
    bday: Yup.date()
      .required('Required')
      .min(subYears(new Date(), 90), 'Too long ago')
      .max(new Date(), 'Cannot be in the future'),
    eircode: Yup.string().required('Required'),
  });

  return (
    <Formik
      initialValues={{
        'given-name': '',
        'family-name': '',
        email: '',
        tel: '',
      }}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        onSubmit(values, () => actions.setSubmitting(false));
      }}
      render={props => (
        <Form className={className}>
          <H4
            css={{
              fontSize: 22,
            }}
          >
            Fill in your details to find out more:
          </H4>
          <FormFieldGroup spacing={2}>
            <View
              css={{
                [BREAKPOINTS.medium]: {
                  display: 'flex',
                  flexDirection: 'row',
                },
              }}
            >
              <FormField
                css={{
                  marginBottom: unit(3),
                  [BREAKPOINTS.medium]: {
                    marginBottom: 0,
                    marginRight: 20,
                  },
                }}
                label="First name"
                name="given-name"
                placeholder="John"
                value={props.values['given-name']}
                error={props.errors['given-name']}
                widget={Input}
                onChange={event =>
                  props.setFieldValue('given-name', event.target.value, false)
                }
              />
              <FormField
                label="Last name"
                name="family-name"
                placeholder="Smith"
                widget={Input}
                value={props.values['family-name']}
                error={props.errors['family-name']}
                onChange={event =>
                  props.setFieldValue('family-name', event.target.value, false)
                }
              />
            </View>
            <View
              css={{
                [BREAKPOINTS.large]: {
                  display: 'flex',
                  flexDirection: 'row',
                },
              }}
            >
              <FormField
                name="bday"
                label="Date of birth"
                value={props.values.bday}
                error={props.errors.bday}
                widget={SplitDateInput}
                widgetProps={{
                  showDay: true,
                }}
                onChange={value => props.setFieldValue('bday', value, false)}
                css={{
                  [BREAKPOINTS.large]: {
                    width: 'calc(60% - 20px)',
                    marginRight: 20,
                  },
                }}
              />

              <FormField
                label="Phone number"
                name="tel"
                placeholder="085 111 2222"
                value={props.values['tel']}
                error={props.errors['tel']}
                widget={Input}
                widgetProps={{ type: 'tel' }}
                onChange={event =>
                  props.setFieldValue('tel', event.target.value, false)
                }
                css={{
                  marginTop: unit(3),
                  [BREAKPOINTS.large]: { marginTop: 0, width: '40%' },
                }}
              />
            </View>
            <FormField
              label="Eircode"
              name="eircode"
              placeholder="A65 F4E2"
              value={props.values['eircode']}
              error={props.errors['eircode']}
              widget={Input}
              onChange={event =>
                props.setFieldValue('eircode', event.target.value, false)
              }
            />
            <FormField
              label="Email"
              name="email"
              placeholder="john.smith@zego.com"
              value={props.values['email']}
              error={props.errors['email']}
              widget={Input}
              widgetProps={{ type: 'email' }}
              onChange={event =>
                props.setFieldValue('email', event.target.value, false)
              }
            />
          </FormFieldGroup>
          <FormActions>
            <Button
              type="submit"
              stretch={true}
              submitting={props.isSubmitting}
            >
              {buttonLabel}
            </Button>
          </FormActions>
          {errorMessage ? (
            <RegularText
              css={{
                fontSize: 12,
                color: errorColor(5),
                textAlign: 'left',
                marginTop: unit(1),
              }}
            >
              {errorMessage}
            </RegularText>
          ) : null}
          <RegularText
            css={{
              marginTop: unit(1),
              fontSize: 12,
              fontWeight: 'normal',
              textAlign: 'center',
            }}
          >
            By continuing you are agreeing to our{' '}
            <Link href="/ie/privacy">Privacy Policy.</Link>
          </RegularText>
        </Form>
      )}
    />
  );
};

export default LeadDetailsForm;
